import React, { useState, useContext } from "react";
import { NavLink, useNavigate, useSearchParams } from "react-router-dom";
import AuthTextField from "../../components/Form/AuthTextField";
import AuthPasswordField from "../../components/Form/AuthPasswordField";
import { GlobalContext } from "../../context/globalContext";
import { loginUserAPI } from "../../api/auth";
import ErrorAlert from "../../components/ErrorAlert/ErrorAlert";
export const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [message, setMessage] = useState("");
  const { setCurrentUser } = useContext(GlobalContext);
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirectTo = searchParams.get("redirect");

  const loginUser = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email || !password) {
      setErrorMessage("Please enter your email and password.");
      return;
    }
    if (!email.includes("@")) {
      setErrorMessage("Please enter a valid email address.");
      return;
    }

    try {
      setIsLoggingIn(true);
      const result = await loginUserAPI({ email, password });
      if (result.ok && result.user) {
        setMessage("Signed in successfully.");
        setCurrentUser(result.user);
        const target =
          redirectTo && redirectTo.startsWith("/") ? redirectTo : "/";
        navigate(target);
      } else {
        setErrorMessage(result.message ?? "Sign in failed. Check your details.");
      }
    } catch (error) {
      console.error("Login error:", error);
      setErrorMessage(
        "Something went wrong. Please try again in a moment.",
      );
    } finally {
      setIsLoggingIn(false);
    }
  };

  return (
    <form
      id="form-login"
      onSubmit={loginUser}
      onChange={() => {
        setErrorMessage("");
        setMessage("");
      }}
    >
      <AuthTextField
        label="Email"
        type="email"
        value={email}
        onChange={setEmail}
        autoComplete="email"
        required
      />
      <AuthPasswordField
        label="Password"
        value={password}
        onChange={setPassword}
        autoComplete="current-password"
        required
      />
      <div className="flex items-center justify-between mb-6 -mt-1">
        <NavLink
          to="/reset-password"
          className="text-sm text-slate-600 hover:text-slate-900 underline"
        >
          Forgot password?
        </NavLink>
      </div>
      <button
        id="login-button"
        type="submit"
        className="eh-btn-primary block w-full py-3 text-sm font-semibold text-center disabled:opacity-60 disabled:cursor-not-allowed"
        disabled={isLoggingIn}
      >
        {isLoggingIn ? "Signing in…" : "Sign in"}
      </button>
      {errorMessage && (
        <ErrorAlert className="mt-4">{errorMessage}</ErrorAlert>
      )}
      {message && (
        <p className="text-green-700 text-sm mt-4">{message}</p>
      )}
    </form>
  );
};
